document.addEventListener("DOMContentLoaded",() =>{
  var CRTurl = new URL(window.location.href);
  if(CRTurl.pathname == "/pages/alb_hyosho_catalog_202512"){
    var enrgt_base = CRTurl.searchParams.get("enrgt");
    if(enrgt_base != null){
      var cnf_rnk = enrgt_base.split("dcr_")[1].replace("u","1").replace("s","2").replace("a","3");
      document.querySelectorAll(".cls_emp_rnk_cnf")[0].setAttribute("data-crt_rnk","dcr_" + cnf_rnk);
      if(cnf_rnk == "3"){
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_f5000"]')[0].setAttribute("style","display:none;");
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_f5000_10000"]')[0].setAttribute("style","display:none;");
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_f10000"]')[0].setAttribute("style","display:none;");
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_all"]')[0].setAttribute("style","display:none;");
      }else if(cnf_rnk == "2"){
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_f10000"]')[0].setAttribute("style","display:none;");
      };
    };
  };
}, false);

function sbmtopchk(){
  document.getElementById("emp_name_num_err_1").setAttribute("class","cls_zip_err-hid");
  document.getElementById("emp_name_num_err_2").setAttribute("class","cls_zip_err-hid");
  document.getElementById("emp_name_num_err_3").setAttribute("class","cls_zip_err-hid");
  document.getElementById("emp_name_num_err_4").setAttribute("class","cls_zip_err-hid");
  var emp_hvp_list = document.getElementsByClassName("al_emnm_list_B")[0].textContent.split("-");
  var sbm_num = document.getElementById("emp_name_num").value;
  var subm_bool_0 = false;
  var subm_bool_1 = false;
  var subm_bool_2 = false;
  if(sbm_num == ""){
    document.getElementById("emp_name_num_err_1").setAttribute("class","cls_zip_err");
  }else{
    if(sbm_num.length != 6){
      document.getElementById("emp_name_num_err_2").setAttribute("class","cls_zip_err");
    }else{
      var subm_bool_0 = true;
    };
  };
  if(subm_bool_0 == true){
    for(var a = 0;a < emp_hvp_list.length;a++){
      var tenn = String(parseInt(emp_hvp_list[a].split("_")[1],16)).padStart(6,"0");
      if(sbm_num == tenn){
        var rem = Number(parseInt(emp_hvp_list[a].split("_")[0],16)) - Number(parseInt(emp_hvp_list[a].split("_")[1],16));
        var subm_bool_1 = true;
        var subm_bool_2 = true;
        break;
      };
    };
    if(subm_bool_1 == true){
      var emp_alrd_list = document.getElementsByClassName("al_emnm_list_A")[0].textContent.replace(/k/g,"0").replace(/C/g,"1").replace(/W/g,"3").replace(/f/g,"6").replace(/P/g,"7").replace(/e/g,"9").split("_");
      for(var b = 0;b < emp_alrd_list.length;b++){
        if(sbm_num == emp_alrd_list[b]){
          document.getElementById("emp_name_num_err_4").setAttribute("class","cls_zip_err");
          var subm_bool_2 = false;
          break;
        };
      };
      if(subm_bool_2 == true ){
        document.getElementsByClassName("list_head_rmi")[0].getElementsByClassName("head_rmi_data")[0].textContent = rem;
        document.getElementsByClassName("list_head_rmi")[0].getElementsByClassName("head_rmi_data")[0].setAttribute("data-fstd",rem);
        document.getElementsByClassName("list_head_rmi")[0].getElementsByClassName("head_rmi_data")[0].setAttribute("data-rmi",rem);
        document.getElementsByClassName("list_head_rmi")[0].getElementsByClassName("head_rmi_data")[0].setAttribute("data-sb",tenn);
        document.getElementById("sbm_chk-top_cnt").setAttribute("style","display:none");
        document.getElementById("emp_name_num").setAttribute("readonly","true");
        document.getElementsByClassName("cls_fst_conf")[0].setAttribute("class","cls_fst_conf");
        rnkcnf_emp(sbm_num);
      };
    }else{
      document.getElementById("emp_name_num_err_3").setAttribute("class","cls_zip_err");
    };
  };
};

function srtprd_pnt(clsprdsrtpnt){
  var prd_list = document.getElementById("prd_list-field-cnt_1119").getElementsByClassName("prd_list_cnt");
  var pnt_f = Number(clsprdsrtpnt.split("_")[0]);
  var pnt_t = Number(clsprdsrtpnt.split("_")[1]);
  var rnk_confirm = "cln_" + document.querySelectorAll(".cls_emp_rnk_cnf")[0].getAttribute("data-crt_rnk").split("dcr_")[1]
  if(clsprdsrtpnt == "all"){
    for(var a = 0;a < prd_list.length;a++){
      var rnk_cls = [...prd_list[a].querySelectorAll(".prd_rnk")[0].classList];
      if(rnk_cls.indexOf(rnk_confirm) > -1){
        prd_list[a].setAttribute("style","display:flex;");
      };
    };
  }else{
    for(var a = 0;a < prd_list.length;a++){
      var rnk_cls = [...prd_list[a].querySelectorAll(".prd_rnk")[0].classList];
      var prd_pnt = Number(prd_list[a].getElementsByClassName("prd_btn")[0].getAttribute("data-prdp"));
      console.log(rnk_cls);
      if(rnk_cls.indexOf(rnk_confirm) > -1){
        if(pnt_t == 0){
          if(pnt_f <= prd_pnt ){
              prd_list[a].setAttribute("style","display:flex;");
          }else{
              prd_list[a].setAttribute("style","display:none;");
          };
        }else{
          if(pnt_f <= prd_pnt && prd_pnt <= pnt_t){
              prd_list[a].setAttribute("style","display:flex;");
          }else{
              prd_list[a].setAttribute("style","display:none;");
          };
        };
      };
    };
  };
};

function frmnumchg(){
  var dcVL = Number(document.getElementById("emp_name_ship_num").value);
  for(var i = 1;i < 4;i++){
    document.getElementById("cls_form_area_" + i).setAttribute("style","display:none;");
  };
  if(dcVL == 1){
    document.getElementById("cls_form_area_1").getElementsByClassName("cls_cnt-ttl")[0].textContent = "■配送先情報";
  }else{
    document.getElementById("cls_form_area_1").getElementsByClassName("cls_cnt-ttl")[0].textContent = "■配送先情報：1箇所目";
  };
  for(var i = 1;i < dcVL + 1;i++){
    document.getElementById("cls_form_area_" + i).setAttribute("style","display:block;");
  };
  rst_clsinp();
  document.getElementsByClassName("cls_sbm_bottom")[0].setAttribute("class","cls_sbm_bottom cls_sbm");
};
function cls_cmp_opn(cls_thele){
  var theled = cls_thele.parentElement.getAttribute("class");
  var fnum = cls_thele.parentElement.parentElement.getAttribute("id");
  var now_sele = cls_thele.getElementsByClassName("cls_prd-data")[0].getAttribute("data-nsele");
  document.getElementById("prd_list-field_1119").setAttribute("data-prdinp",theled);
  document.getElementById("prd_list-field_1119").setAttribute("data-prdfnum",fnum);
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].setAttribute("data-resel",now_sele);
  var rem = document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].getAttribute("data-rmi");
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].setAttribute("data-rmi",Number(rem) + Number(now_sele));
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].textContent = Number(rem) + Number(now_sele);
  document.getElementById("prd_list-field_1119").setAttribute("class","prd_list-field");
  document.getElementById("prd_list-field-cnt_1119").setAttribute("class","prd_list-field-cnt");
};
function cls_cmp_cls(){
  document.getElementById("prd_list-field_1119").setAttribute("data-prdinp","");
  var now_sele = document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].getAttribute("data-resel");
  var rem = document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].getAttribute("data-rmi");
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].setAttribute("data-rmi",Number(rem) - Number(now_sele));
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].textContent = Number(rem) - Number(now_sele);
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].setAttribute("data-resel","0");
  document.getElementById("prd_list-field_1119").setAttribute("class","prd_list-field-hid");
  document.getElementById("prd_list-field-cnt_1119").setAttribute("class","prd_list-field-cnt-hid");
};
function st_prdnm(cls_btnele){
  document.getElementById("list_rim_err").setAttribute("class","cls_rim_err-hid");
  var fnum = document.getElementById(document.getElementById("prd_list-field_1119").getAttribute("data-prdfnum"));
  var rim = Number(document.getElementsByClassName("list_head_rmi")[0].getElementsByClassName("head_rmi_data")[0].getAttribute("data-rmi")) - Number(cls_btnele.getAttribute("data-prdp"));
  if(rim >= 0){
    document.getElementsByClassName("list_head_rmi")[0].getElementsByClassName("head_rmi_data")[0].textContent = rim;
    document.getElementsByClassName("list_head_rmi")[0].getElementsByClassName("head_rmi_data")[0].setAttribute("data-rmi",rim);
    var thd = document.getElementById("prd_list-field_1119").getAttribute("data-prdinp");
    var vle = cls_btnele.getAttribute("data-prdnm");
    document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].setAttribute("data-resel","0");
    fnum.getElementsByClassName(thd)[0].getElementsByTagName("input")[0].setAttribute("data-nsele",Number(cls_btnele.getAttribute("data-prdp")));
    fnum.getElementsByClassName(thd)[0].getElementsByTagName("input")[0].setAttribute("value",vle); 
    document.getElementById("prd_list-field_1119").setAttribute("data-prdinp","");
    document.getElementById("prd_list-field_1119").setAttribute("class","prd_list-field-hid");
    document.getElementById("prd_list-field-cnt_1119").setAttribute("class","prd_list-field-cnt-hid");
  }else{
    document.getElementById("list_rim_err").setAttribute("class","cls_rim_err");
  };
};
function cls_add_prdf(cls_addele){
  var fnum = document.getElementById("cls_form_area_" + cls_addele.getAttribute("data-fpnum"));
  var n = fnum.getElementsByClassName("cls_frm_product").length - 1;
  var cls_n = fnum.getElementsByClassName("cls_frm_product")[n].getAttribute("class").replace("cls_frm-flx cfp_w_b","cls_frm-blk");
  if(fnum.getElementsByClassName("cls_frm_product")[n].getAttribute("class") != "cls_frm_product cls_frm cls_frm-blk cls_frm_product_1"){
    fnum.getElementsByClassName("cls_frm_product")[n].getElementsByClassName("cls_prdfield_dlt")[0].remove();
  };
  fnum.getElementsByClassName("cls_frm_product")[n].setAttribute("class",cls_n);
  var f = fnum.getElementsByClassName("cls_frm_product").length + 1;
  var fld = document.createElement("div");
  var cls_v = "cls_frm_product_" + f;
  fld.setAttribute("class","cls_frm_product cls_frm cls_frm-flx cfp_w_b " + cls_v);
  var div = document.createElement("div");
  div.setAttribute("onclick","cls_cmp_opn(this)");
  div.setAttribute("class","cls_prd_put");
  var inp = document.createElement("input");
  inp.setAttribute("class","cls_prd-data");
  inp.setAttribute("type","text");
  inp.setAttribute("data-nsele","0");
  inp.setAttribute("readonly","true");
  inp.setAttribute("placeholder","商品を選ぶ（" + f + "点目）");
  var div_2 = document.createElement("div");
  div_2.setAttribute("class","cls_zip_err-hid cls_prd-err");
  div_2.textContent = "*商品が未入力です。商品を選択するか、入力欄を削除してください。"
  div.appendChild(inp);
  div.appendChild(div_2);
  fld.appendChild(div);
  var btn = document.createElement("div");
  btn.setAttribute("class","cls_prdfield_dlt");
  btn.setAttribute("data-fpnum",cls_addele.getAttribute("data-fpnum"));
  btn.setAttribute("onclick","cls_dlt_prdf(this)");
  btn.textContent = "削除";
  fld.appendChild(btn);
  cls_addele.before(fld);
};
function cls_dlt_prdf(cls_dltele){
  var fnum = document.getElementById("cls_form_area_" + cls_dltele.getAttribute("data-fpnum"));
  var f = fnum.getElementsByClassName("cls_frm_product").length - 2;
  if(fnum.getElementsByClassName("cls_frm_product")[f].getAttribute("class") != "cls_frm_product cls_frm cls_frm-blk cls_frm_product_1"){
    var btn = document.createElement("div");
    btn.setAttribute("class","cls_prdfield_dlt");
    btn.setAttribute("data-fpnum",cls_dltele.getAttribute("data-fpnum"));
    btn.setAttribute("onclick","cls_dlt_prdf(this)");
    btn.textContent = "削除";
    var cls_n = fnum.getElementsByClassName("cls_frm_product")[f].getAttribute("class").replace("cls_frm-blk","cls_frm-flx cfp_w_b");
    fnum.getElementsByClassName("cls_frm_product")[f].setAttribute("class",cls_n);
    fnum.getElementsByClassName("cls_frm_product")[f].appendChild(btn);
  };
  var now_sele = cls_dltele.parentElement.getElementsByClassName("cls_prd-data")[0].getAttribute("data-nsele");
  var rem = document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].getAttribute("data-rmi");
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].setAttribute("data-rmi",Number(rem) + Number(now_sele));
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].textContent = Number(rem) + Number(now_sele);
  var fld = cls_dltele.parentElement.remove();
};

function rst_clsinp(){
  var fmc = document.getElementsByClassName("cls_form_area");
  for(var a=0;a < fmc.length;a++){
    if(fmc[a].getAttribute("style") == "display:none;"){
      var inp = fmc[a].getElementsByClassName("cls_prd-data");
      for(var b=0;b < inp.length;b++){
        inp[b].setAttribute("data-nsele","0");
        inp[b].setAttribute("value","");
      };
    };
  };
  var rem = 0;
  for(var a=0;a < fmc.length;a++){
    if(fmc[a].getAttribute("style") != "display:none;"){
      var inp = fmc[a].getElementsByClassName("cls_prd-data");
      for(var b=0;b < inp.length;b++){
        var rem = rem + Number(inp[b].getAttribute("data-nsele"));
      };
    };
  };
  var newv = Number(document.getElementsByClassName("list_head_rmi")[0].getElementsByClassName("head_rmi_data")[0].getAttribute("data-fstd")) - rem;
  document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].setAttribute("data-rmi",newv);
};

function cls_srczip(cls_frmnum){ 
  var strt_zipknsk = document.getElementById("cls_zip_base_" + cls_frmnum).getAttribute("data-strt_zip");
  if(strt_zipknsk == "true"){
    document.getElementById("cls_zip_base_" + cls_frmnum).setAttribute("data-strt_zip","false");
    document.getElementById("cls_ziper_1_" + cls_frmnum).setAttribute("class","cls_zip_err-hid");
    document.getElementById("cls_ziper_2_" + cls_frmnum).setAttribute("class","cls_zip_err-hid");
    document.getElementById("cls_ziper_3_" + cls_frmnum).setAttribute("class","cls_zip_err-hid");
    document.getElementById("cls_ziper_4_" + cls_frmnum).setAttribute("class","cls_zip_err-hid");
    var get_zip_data = true;
    var inpz_vl = document.getElementById("cls_zip_base_" + cls_frmnum).value.replace(/-/g,"");
    var inpz_vl_spl = inpz_vl.substr(0,3) + "-" + inpz_vl.substr(3,4)
    var zt_div_list = document.getElementById("zip_cand_li_" + cls_frmnum).getElementsByClassName("brn_cand_cnt");
    for(var a = zt_div_list.length - 1;a >= 0 ;a--){
      var inpz_vl_get = zt_div_list[a].getAttribute("data-brn_adA");
      if(inpz_vl_spl == inpz_vl_get){
        var get_zip_data = false;
      };
      zt_div_list[a].remove();
    };
    if(get_zip_data == true){
      if(inpz_vl.length == 7){
        document.getElementById("spc_load_pap").className = "spc_load_vis";
        var zt_list = document.getElementById("zip_cand_li_" + cls_frmnum).getElementsByClassName("zip_cand_list_body")[0];
        var pndzipl = "https:" + document.getElementById("srchp_base_" + cls_frmnum).getAttribute("data-pndzpl");
        jQuery.ajax({type: 'GET',url: pndzipl,dataType:"text"})
        .then(
            function(zt_data) {
            var zt_dict = JSON.parse(zt_data);
            if(inpz_vl in zt_dict){
              var zt_dict_hit = zt_dict[inpz_vl];
              for(var b = 0;b < zt_dict_hit.length;b++){
                var zt_div = document.createElement("div");
                zt_div.textContent = "〒" + inpz_vl.substr(0,3) + "-" + inpz_vl.substr(3,4) + "：" + zt_dict_hit[b][0] + zt_dict_hit[b][1] + zt_dict_hit[b][2];
                zt_div.setAttribute("data-brn_adA",inpz_vl.substr(0,3) + "-" + inpz_vl.substr(3,4));
                zt_div.setAttribute("data-brn_adB",zt_dict_hit[b][0]);
                zt_div.setAttribute("data-brn_adC",zt_dict_hit[b][1]);
                zt_div.setAttribute("data-brn_adD",zt_dict_hit[b][2]);
                zt_div.setAttribute("data-frm_num",cls_frmnum);
                zt_div.setAttribute("onclick","brn_setzip(this)");
                zt_div.className = "brn_cand_cnt";
                zt_list.appendChild(zt_div);
              };
              if(zt_dict_hit.length == 1){
                document.getElementById("zip_cand_li_" + cls_frmnum).className = "zip_cand_list";
                document.getElementById("cls_zip_base_" + cls_frmnum).setAttribute("data-strt_zip","true");
              }else{
                document.getElementById("zip_cand_li_" + cls_frmnum).className = "zip_cand_list_long";
                document.getElementById("cls_zip_base_" + cls_frmnum).setAttribute("data-strt_zip","true");
              };
            }else{
              document.getElementById("cls_ziper_2_" + cls_frmnum).setAttribute("class","cls_zip_err");
              document.getElementById("cls_zip_base_" + cls_frmnum).setAttribute("data-strt_zip","true");
            };
          })
        .fail(
          function() {
            document.getElementById("cls_ziper_3_" + cls_frmnum).setAttribute("class","cls_zip_err");
            document.getElementById("cls_zip_base_" + cls_frmnum).setAttribute("data-strt_zip","true");
          })
        document.getElementById("spc_load_pap").className = "spc_load_hid";
      }else{
        document.getElementById("cls_ziper_1_" + cls_frmnum).setAttribute("class","cls_zip_err");
        document.getElementById("cls_zip_base_" + cls_frmnum).setAttribute("data-strt_zip","true");
      };
    }else{
      document.getElementById("cls_zip_base_" + cls_frmnum).setAttribute("data-strt_zip","true");
    };
  };
};

function brn_setzip(z_inp_dt){
  var brn_adA = z_inp_dt.getAttribute("data-brn_adA");
  var brn_adB = z_inp_dt.getAttribute("data-brn_adB");
  var brn_adC = z_inp_dt.getAttribute("data-brn_adC");
  var brn_adD = z_inp_dt.getAttribute("data-brn_adD");
  var cls_frmnum = z_inp_dt.getAttribute("data-frm_num");
  document.getElementById("cls_zip_base_" + cls_frmnum).value = brn_adA;
  document.getElementsByClassName("cls_frm_prv_" + cls_frmnum)[0].getElementsByTagName("input")[0].value = brn_adB;
  document.getElementsByClassName("cls_frm_ad1_" + cls_frmnum)[0].getElementsByTagName("input")[0].value = brn_adC;
  document.getElementsByClassName("cls_frm_ad2_" + cls_frmnum)[0].getElementsByTagName("input")[0].value = brn_adD;
  var zt_div_list = document.getElementById("zip_cand_li_" + cls_frmnum).getElementsByClassName("brn_cand_cnt");
  for(var a = zt_div_list.length - 1;a >= 0 ;a--){
    zt_div_list[a].remove();
  };
  document.getElementById("zip_cand_li_" + cls_frmnum).className = "zip_cand_list-hid";
};


function brn_zip_cand_cls(z_inp_dt_b){
  document.getElementById("zip_cand_li_" + z_inp_dt_b).className = "zip_cand_list-hid";
};

document.addEventListener('click', function(e){
  if(!e.target.closest("#zip_cand_li_1")) {
    document.getElementById("zip_cand_li_1").className = "zip_cand_list-hid";
    var zt_div_list = document.getElementById("zip_cand_li_1").getElementsByClassName("brn_cand_cnt");
    for(var a = zt_div_list.length - 1;a >= 0 ;a--){
      zt_div_list[a].remove();
    };
  };
});

function chk_fmdata(){
  var chk_cnf = true;
  document.getElementById("emp_name_num_err_0").setAttribute("class","cls_zip_err-hid");
  document.getElementById("emp_name_tll_err_0").setAttribute("class","cls_zip_err-hid");
  document.getElementById("emp_name_num_err_1").setAttribute("class","cls_zip_err-hid");
  document.getElementById("emp_name_num_err_2").setAttribute("class","cls_zip_err-hid");
  document.getElementById("cls_frm_knsu_err").setAttribute("class","cls_zip_err-hid");
  document.getElementById("cls_frm_rim_err").setAttribute("class","cls_zip_err-hid");
  document.getElementById("cls_frm_rim_err").textContent = "";
  var fmc = document.getElementsByClassName("cls_form_area");
  for(var a=0;a < fmc.length;a++){
    var n = fmc[a].getAttribute("id").replace("cls_form_area_","");
    document.getElementById("cls_frm_name_err_" + n).setAttribute("class","cls_zip_err-hid");
    document.getElementById("cls_frm_tel_err_" + n).setAttribute("class","cls_zip_err-hid");
    document.getElementById("cls_ziper_4_" + n).setAttribute("class","cls_zip_err-hid");
    document.getElementById("cls_frm_prv_err_" + n).setAttribute("class","cls_zip_err-hid");
    document.getElementById("cls_frm_ad1_err_" + n).setAttribute("class","cls_zip_err-hid");
    document.getElementById("cls_frm_ad2_err_" + n).setAttribute("class","cls_zip_err-hid");
    var prd_data_cnt = fmc[a].getElementsByClassName("cls_prd-data");
    for(var b=0;b < prd_data_cnt.length;b++){
      var prd_data = prd_data_cnt[b].value;
      prd_data_cnt[b].parentElement.getElementsByClassName("cls_prd-err")[0].setAttribute("class","cls_zip_err-hid cls_prd-err");
    };
  };

  var all_data = [];
  var fmc_len = 0;
  var emp_s = document.getElementById("emp_name_sei").value.replace(/ /g,"").replace(/　/g,"");
  var emp_m = document.getElementById("emp_name_mei").value.replace(/ /g,"").replace(/　/g,"");
  var emp_B = document.getElementById("emp_name_num").value.replace(/ /g,"").replace(/　/g,"");
  var emp_T = document.getElementById("emp_maintl").value.replace(/ /g,"").replace(/　/g,"");
  var emp_rem = document.getElementById("prd_list-field_1119").getElementsByClassName("head_rmi_data")[0].getAttribute("data-rmi");
  all_data.push(emp_s);
  all_data.push(emp_m);
  all_data.push(emp_B);
  all_data.push(emp_T);
  if(emp_s == "" || emp_m == ""){
    document.getElementById("emp_name_num_err_0").setAttribute("class","cls_zip_err");
    var chk_cnf = false;
  };
  if(emp_B == ""){
    document.getElementById("emp_name_num_err_1").setAttribute("class","cls_zip_err");
    var chk_cnf = false;
  }else if(emp_B.length != 6){
    document.getElementById("emp_name_num_err_2").setAttribute("class","cls_zip_err");
    var chk_cnf = false;
  };
  if(emp_T == ""){
    document.getElementById("emp_name_tll_err_0").setAttribute("class","cls_zip_err");
    var chk_cnf = false;
  };
  if(document.querySelectorAll("#cls_alb_knsu_field_descr_text").length > 0){
    if(document.querySelectorAll("#cls_alb_knsu_field_descr_text")[0].value == ""){
      document.getElementById("cls_frm_knsu_err").setAttribute("class","cls_zip_err");
      var chk_cnf = false;
    };
  };
  if(emp_rem > 0){
    document.getElementById("cls_frm_rim_err").textContent = "*ポイントが残っています（" + emp_rem + "ポイント）";
    document.getElementById("cls_frm_rim_err").setAttribute("class","cls_zip_err");
    var chk_cnf = false;
  };
  frm_list = [];
  for(var a=0;a < fmc.length;a++){
    if(fmc[a].getAttribute("style") != "display:none;"){
      var frm_data = [];
      var fmc_len = fmc_len + 1;
      var n = fmc[a].getAttribute("id").replace("cls_form_area_","");
      var ship_s = fmc[a].getElementsByClassName("ship_sei")[0].value;
      var ship_m = fmc[a].getElementsByClassName("ship_mei")[0].value;
      var ship_phone = fmc[a].getElementsByClassName("cls_frm_tel")[0].getElementsByTagName("input")[0].value.replace(/ /g,"").replace(/　/g,"");
      var ship_zip = fmc[a].getElementsByClassName("cls_frm_zip")[0].getElementsByTagName("input")[0].value.replace(/ /g,"").replace(/　/g,"");
      var ship_prv = fmc[a].getElementsByClassName("cls_frm_prv_" + n)[0].getElementsByTagName("input")[0].value.replace(/ /g,"").replace(/　/g,"");
      var ship_ad1 = fmc[a].getElementsByClassName("cls_frm_ad1_" + n)[0].getElementsByTagName("input")[0].value.replace(/ /g,"").replace(/　/g,"");
      var ship_ad2 = fmc[a].getElementsByClassName("cls_frm_ad2_" + n)[0].getElementsByTagName("input")[0].value.replace(/ /g,"").replace(/　/g,"");
      var ship_ad3 = fmc[a].getElementsByClassName("cls_frm_ad3_" + n)[0].getElementsByTagName("input")[0].value.replace(/ /g,"").replace(/　/g,"");
      var prd_data_cnt = fmc[a].getElementsByClassName("cls_prd-data");
      frm_data.push(ship_s);
      frm_data.push(ship_m);
      frm_data.push(ship_phone);
      frm_data.push(ship_zip);
      frm_data.push(ship_prv);
      frm_data.push(ship_ad1);
      frm_data.push(ship_ad2);
      frm_data.push(ship_ad3);
      var prd_data_LIST = [];
      for(var b=0;b < prd_data_cnt.length;b++){
        var prd_data = prd_data_cnt[b].value;
        prd_data_LIST.push(prd_data);
        if(prd_data == ""){prd_data_cnt[b].parentElement.getElementsByClassName("cls_prd-err")[0].setAttribute("class","cls_zip_err cls_prd-err");var chk_cnf = false;};
      };
      frm_data.push(prd_data_LIST);
      if(ship_s == "" || ship_m == ""){document.getElementById("cls_frm_name_err_" + n).setAttribute("class","cls_zip_err");var chk_cnf = false;};
      if(ship_phone == ""){document.getElementById("cls_frm_tel_err_" + n).setAttribute("class","cls_zip_err");var chk_cnf = false;};
      if(ship_zip == ""){document.getElementById("cls_ziper_4_" + n).setAttribute("class","cls_zip_err");var chk_cnf = false;};
      if(ship_prv == ""){document.getElementById("cls_frm_prv_err_" + n).setAttribute("class","cls_zip_err");var chk_cnf = false;};
      if(ship_ad1 == ""){document.getElementById("cls_frm_ad1_err_" + n).setAttribute("class","cls_zip_err");var chk_cnf = false;};
      if(ship_ad2 == ""){document.getElementById("cls_frm_ad2_err_" + n).setAttribute("class","cls_zip_err");var chk_cnf = false;};
      frm_list.push(frm_data);
    };
  };
  if(document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref") == null){
    var chk_cnf = false;
  };
  if(document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref") != null && chk_cnf == true){
    if(document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input").length != 4){
      document.getElementById("cls_frm_subm_err").setAttribute("class","cls_zip_err");
      var chk_cnf = false;
    };
  };
  if(chk_cnf == true){
    var exstD = document.getElementsByClassName("cls_conf_shipping_dt");
    for(var a = exstD.length - 1;a >= 0 ;a--){exstD[a].remove()};
    all_data.push(frm_list);
    var cnfF = document.getElementsByClassName("cnf-field")[0];
    cnfF.getElementsByClassName("cls_conf_name")[0].getElementsByClassName("cls_cnf_data")[0].textContent = all_data[0] + "　" + all_data[1];
    cnfF.getElementsByClassName("cls_conf_numb")[0].getElementsByClassName("cls_cnf_data")[0].textContent = all_data[2];
    cnfF.getElementsByClassName("cls_conf_tlle")[0].getElementsByClassName("cls_cnf_data")[0].textContent = all_data[3];
    cnfF.getElementsByClassName("cls_conf_sips")[0].getElementsByClassName("cls_cnf_data")[0].textContent = all_data[4].length + "箇所";
    for(var a=0;a < all_data[4].length;a++){
      var b = a + 1;
      var spF = document.createElement("div");
      spF.setAttribute("class","cls_conf_shipping_dt spd_" + b);
      var spF_ttl = document.createElement("div");
      spF_ttl.setAttribute("class","cls_conf_sttl");
      if(a == 0 && fmc_len == 1){spF_ttl.textContent = "■配送先情報";}else{spF_ttl.textContent = "■配送先情報：" + b + "箇所目";};
      spF.appendChild(spF_ttl);
      var spF_name = document.createElement("div");
      spF_name.setAttribute("class","cls_conf_sip_n clsc_1");
      var spF_spn1 = document.createElement("span");
      spF_spn1.textContent = "配送先氏名：";
      spF_spn1.setAttribute("class","cls_cnf_ttl");
      spF_name.appendChild(spF_spn1);
      var spF_spn2 = document.createElement("span");
      spF_spn2.setAttribute("class","cls_cnf_data");
      spF_spn2.textContent = all_data[4][a][0] + "　" + all_data[4][a][1];
      spF_name.appendChild(spF_spn2);
      spF.appendChild(spF_name);
      var spF_prd = document.createElement("div");
      spF_prd.setAttribute("class","cls_conf_prdlist clsc_1");
      var spF_p1 = document.createElement("div");
      spF_p1.setAttribute("class","cls_cnf_ttl");
      spF_p1.textContent = "注文商品";
      spF_prd.appendChild(spF_p1);
      var spF_p2 = document.createElement("div");
      spF_p2.setAttribute("class","cls_conf_prdlist_list");
      for(var c=0;c < all_data[4][a][8].length;c++){
        var spF_pcnt = document.createElement("div");
        spF_pcnt.textContent = "・" + all_data[4][a][8][c];
        spF_p2.appendChild(spF_pcnt);
      };
      spF_prd.appendChild(spF_p2);
      spF.appendChild(spF_prd);
      spF_cls = ["cls_conf_sip_p","cls_conf_sip_z","cls_conf_sip_ad1"];
      for(var d=0;d<spF_cls.length;d++){
        var spF_div = document.createElement("div");
        spF_div.setAttribute("class",spF_cls[d] + " clsc_1");
        var spF_spnT = document.createElement("span");
        spF_spnT.setAttribute("class","cls_cnf_ttl");
        spF_div.appendChild(spF_spnT);
        var spF_spnD = document.createElement("span");
        spF_spnD.setAttribute("class","cls_cnf_data");
        spF_div.appendChild(spF_spnD);
        if(d == 0){
          spF_spnT.textContent = "配送先電話番号：";
          spF_spnD.textContent = all_data[4][a][2];
        }else if(d == 1){
          spF_spnT.textContent = "郵便番号：";
          spF_spnD.textContent = all_data[4][a][3];
        }else if(d == 2){
          spF_spnT.textContent = "住所：";
          spF_spnD.textContent = all_data[4][a][4] + all_data[4][a][5] + all_data[4][a][6] + "　" + all_data[4][a][7];
        };
        spF.appendChild(spF_div);
      };
      cnfF.getElementsByClassName("cls_conf_content")[0].appendChild(spF);
      document.getElementsByClassName("cnf-field")[0].setAttribute("class","cls_conf_main cnf-field");
    };
    document.getElementById("sbm_btn_cnt").setAttribute("style","display:none;");
    var sbm_inpdata_fnl = "";
    for(var a=0;a < all_data[4].length;a++){
      var forinp = all_data[4][a][0] + "|@_@|" + all_data[4][a][1] + "|@_@|" + all_data[4][a][2] + "|@_@|" + all_data[4][a][3] + "|@_@|" + all_data[4][a][4] + all_data[4][a][5] + all_data[4][a][6] + "　" + all_data[4][a][7];
      var forprd = "";
      for(var c=0;c < all_data[4][a][8].length;c++){
        var forprd = forprd + all_data[4][a][8][c] + "|@=@|";
      };
      var sbm_inpdata_fnl = sbm_inpdata_fnl + forinp + "|@_@|" + forprd + "|]@[|"
    };
    var alb_knsu_data = "";
    if(document.querySelectorAll("#cls_alb_knsu_field_descr_text").length > 0){
      var alb_knsu_data = "[|*TXT*|]" + document.querySelectorAll("#cls_alb_knsu_field_descr_text")[0].value;
    };
    const clset = new Event('input', { bubbles: true });
    const clset_cng = new Event('change', { bubbles: true });
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[0].setAttribute("aria-invalid","false");
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[0].value = all_data[0] + "　" + all_data[1] + "|T_T|" + all_data[3];
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[0].dispatchEvent(clset_cng);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[0].dispatchEvent(clset);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[1].setAttribute("aria-invalid","false");
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[1].value = "pandaselectionssakaids215a64sa86dqadf1d5f84a864@gmail.com";
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[1].dispatchEvent(clset_cng);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[1].dispatchEvent(clset);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[2].setAttribute("aria-invalid","false");
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[2].value = sbm_inpdata_fnl + alb_knsu_data;
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[2].dispatchEvent(clset_cng);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[2].dispatchEvent(clset);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[3].setAttribute("aria-invalid","false");
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[3].value = all_data[2];
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[3].dispatchEvent(clset_cng);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[3].dispatchEvent(clset);
  }else{
    document.getElementsByClassName("cls_zip_err")[0].setAttribute("style","margin:-4rem 4.5px 0px;padding:4rem 0 0 0;");
    document.getElementsByClassName("cls_zip_err")[0].scrollIntoView({ behavior: "smooth", block: "start" });
    document.getElementsByClassName("cls_zip_err")[0].setAttribute("style","");
  };
};

function clscnf_N(){
  document.getElementById("sbm_btn_cnt").setAttribute("style","display:block;");
  document.getElementById("cls_frm_cnf_tmout_err").setAttribute("class","cls_zip_err-hid");
  document.getElementsByClassName("cnf-field")[0].setAttribute("class","cls_conf_main-hid cnf-field");
};

function clscnf_Y(){
  document.getElementById("sbm_btn_cnt").setAttribute("style","display:block;");
  document.getElementById("cls_frm_cnf_tmout_err").setAttribute("class","cls_zip_err-hid");
  document.getElementsByClassName("cls_rwnd_lst")[0].setAttribute("class","cls_rwnd_lst conf_rwndcls");
  document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("button")[0].click();
  cls_wtele(8000);
};

function cls_wtele(timeout){
    return new Promise((resolve, reject) => {
        const start = Date.now();
        function cls_wt_chkE(){
            const cls_fm_scet = document.getElementById("app-embed").shadowRoot.querySelector('section[data-testid="banner-success"]');
            if(cls_fm_scet) {
              document.getElementsByClassName("cls_conf_bottom")[0].getElementsByClassName("cls_conf_btm_ttl-sub")[0].remove();
              document.getElementsByClassName("cls_conf_bottom")[0].getElementsByClassName("cls_conf_btm_Y btm_btn")[0].remove();
              document.getElementsByClassName("cls_conf_bottom")[0].getElementsByClassName("cls_conf_btm_N btm_btn")[0].remove();
              document.getElementsByClassName("cls_conf_bottom")[0].getElementsByClassName("cls_rwnd_lst")[0].remove();
              document.getElementsByClassName("cls_conf_bottom")[0].getElementsByClassName("cls_conf_btm_ttl-main")[0].setAttribute("style","color:#d92297;")
              document.getElementsByClassName("cls_conf_bottom")[0].getElementsByClassName("cls_conf_btm_ttl-main")[0].textContent = "■注文の送信が完了しました。注文商品・配送先については、スクリーンショット等でデータを残しておくことをおすすめいたします。完了しましたら、こちらのページは閉じていただいて問題ございません。";
              document.getElementsByClassName("cls_rwnd_lst")[0].setAttribute("class","cls_rwnd_lst　conf_rwndcls-hid");
              resolve(cls_fm_scet);
            }else if(Date.now() - start >= timeout) {
              document.getElementById("cls_frm_cnf_tmout_err").setAttribute("class","cls_zip_err")
              document.getElementsByClassName("cls_rwnd_lst")[0].setAttribute("class","cls_rwnd_lst conf_rwndcls-hid");
              reject(new Error("要素が指定時間内に見つかりませんでした"));
            }else{
              setTimeout(cls_wt_chkE, 500);
            };
        };
        cls_wt_chkE();
    });
};

function rnkcnf_emp(enm_rnkk){
  var enm_value = enm_rnkk;
  var er_list = document.querySelectorAll(".cls_emp_rnk_cnf")[0].getAttribute("data-cerc").split("-");
  for(var ef = 0;ef < er_list.length;ef++){
    var cnf_enum = parseInt(er_list[ef].split("_")[0], 16);
    var cnf_rnk = er_list[ef].split("_")[1].replace("A","1").replace("B","2").replace("C","3");
    if(enm_value == cnf_enum){
      document.querySelectorAll(".cls_emp_rnk_cnf")[0].setAttribute("data-crt_rnk","dcr_" + cnf_rnk);
      if(cnf_rnk == "3"){
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_f5000"]')[0].setAttribute("style","display:none;");
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_f5000_10000"]')[0].setAttribute("style","display:none;");
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_f10000"]')[0].setAttribute("style","display:none;");
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_all"]')[0].setAttribute("style","display:none;");
      }else if(cnf_rnk == "2"){
        document.querySelectorAll('.list_srt_btn[for="list_srt_inp_f10000"]')[0].setAttribute("style","display:none;");
      };
      break;
    };
  };
};


/*
document.querySelectorAll(".prd_bkn_slct").forEach(pbslc => {
    pbslc.addEventListener('change', () => {
        var el_d = pbslc.getAttribute("id");
        var slc_v_0 = document.querySelectorAll(".prd_list_cnt:has(#" + el_d + ") .prd_ttl")[0].getAttribute("data-ptv");
        var slc_v_1 = document.querySelectorAll(".prd_list_cnt:has(#" + el_d + ") .prd_bkn_slct")[0].value;
        var slc_v_2 = document.querySelectorAll(".prd_list_cnt:has(#" + el_d + ") .prd_bkn_slct")[1].value;
        var cnc_key = slc_v_0 + "/" + slc_v_1 + "/" + slc_v_2;
        console.log(cnc_key);
        var bkn_dict = {"BAKUNE メンズ/ネイビー/Sサイズ":"18255202","BAKUNE メンズ/ネイビー/Mサイズ":"18255203","BAKUNE メンズ/ネイビー/Lサイズ":"18255204","BAKUNE メンズ/ネイビー/XLサイズ":"18255205","BAKUNE メンズ/ネイビー/2XLサイズ":"18255206","BAKUNE メンズ/ダークグレー/Sサイズ":"18255222","BAKUNE メンズ/ダークグレー/Mサイズ":"18255223","BAKUNE メンズ/ダークグレー/Lサイズ":"18255224","BAKUNE メンズ/ダークグレー/XLサイズ":"18255225","BAKUNE メンズ/ダークグレー/2XLサイズ":"18255226","BAKUNE ウィメンズ/ピンク/Sサイズ":"18255232","BAKUNE ウィメンズ/ピンク/Mサイズ":"18255233","BAKUNE ウィメンズ/ピンク/Lサイズ":"18255234","BAKUNE ウィメンズ/ピンク/XLサイズ":"18255235","BAKUNE ウィメンズ/ネイビー/Sサイズ":"18255212","BAKUNE ウィメンズ/ネイビー/Mサイズ":"18255213","BAKUNE ウィメンズ/ネイビー/Lサイズ":"18255214","BAKUNE ウィメンズ/ネイビー/XLサイズ":"18255215"};
        if(cnc_key in bkn_dict){
          var prdnm = cnc_key + " : " + bkn_dict[cnc_key];
          document.querySelectorAll(".prd_list_cnt:has(#" + el_d + ") .prd_btn")[0].setAttribute("data-prdnm",prdnm);
          document.querySelectorAll(".prd_list_cnt:has(#" + el_d + ") .prd_btn")[0].setAttribute("class","prd_btn");
        };
    });
});
document.getElementById("prd_bkn_put_1").addEventListener('click', () => {
  var cnf_dt_elm = document.getElementById("prd_bkn_put_1");
  var cnf_dt = cnf_dt_elm.getAttribute("data-prdnm");
  if(cnf_dt != ""){
    st_prdnm(cnf_dt_elm);
  };
});
document.getElementById("prd_bkn_put_2").addEventListener('click', () => {
  var cnf_dt_elm = document.getElementById("prd_bkn_put_2");
  var cnf_dt = cnf_dt_elm.getAttribute("data-prdnm");
  if(cnf_dt != ""){
    st_prdnm(cnf_dt_elm);
  };
});
*/
/*document.getElementById("tssttsts").addEventListener('click', () => {
    console.log("fff");
    const clset = new Event('input', { bubbles: true });
    const clset_cng = new Event('change', { bubbles: true });
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[0].setAttribute("aria-invalid","false");
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[0].value = "A";
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[0].dispatchEvent(clset_cng);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[0].dispatchEvent(clset);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[1].setAttribute("aria-invalid","false");
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[1].value = "pandaselectionssakaids215a64sa86dqadf1d5f84a864@gmail.com";
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[1].dispatchEvent(clset_cng);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[1].dispatchEvent(clset);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[2].setAttribute("aria-invalid","false");
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[2].value = "B";
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[2].dispatchEvent(clset_cng);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[2].dispatchEvent(clset);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[3].setAttribute("aria-invalid","false");
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[3].value = "C";
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[3].dispatchEvent(clset_cng);
    document.getElementById("app-embed").shadowRoot.getElementById("form-container-ref").getElementsByTagName("input")[3].dispatchEvent(clset);
});*/